import styled from "styled-components";
import Colors from "../../../../themes/Colors";

const CampaignDetailHolder = styled.div`
  width: 100%;

  .ant-btn-primary,
  .ant-btn-primary:active {
    background-color: ${Colors.primary};
    border-color: ${Colors.primary};
  }
  .ant-btn-primary:hover,
  .ant-btn-primary:focus {
    background-color: ${Colors.backgroundPrimary};
    border-color: ${Colors.backgroundPrimary};
  }

  .campaignDetail__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
    margin-bottom: 20px;
  }

  .campaignDetail__breadcrumb {
    font-size: 14px;
    color: ${Colors.grayMedium};
  }

  .campaignDetail__breadcrumb-link {
    color: ${Colors.grayMedium};
    cursor: pointer;
  }

  .campaignDetail__breadcrumb-link:hover {
    color: ${Colors.primaryAccent};
  }

  .campaignDetail__actions {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
  }

  .campaignDetail__actions .ant-btn {
    border-radius: 8px;
  }

  .campaignDetail__title {
    font-size: 28px;
    font-weight: 700;
    color: ${Colors.coal};
    margin: 0;
  }

  .campaignDetail__subtitle {
    font-size: 14px;
    color: ${Colors.grayMedium};
    margin: 0 0 16px;
  }

  .campaignDetail__panel {
    background: ${Colors.snow};
    border: 1px solid ${Colors.border};
    border-radius: 8px;
    padding: 24px;
  }

  .campaignDetail__card {
    margin-bottom: 28px;
  }

  .campaignDetail__card:last-child {
    margin-bottom: 0;
  }

  .campaignDetail__card + .campaignDetail__card {
    padding-top: 8px;
  }

  .campaignDetail__section-title {
    font-size: 14px;
    font-weight: 700;
    color: ${Colors.textStrong};
    margin: 20px 0 12px;
  }

  .campaignDetail__grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(175px, 1fr));
    gap: 12px;
  }

  .campaignDetail__infoCard {
    border: 1px solid ${Colors.border};
    border-radius: 10px;
    padding: 12px 14px;
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .campaignDetail__infoCard-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 20px;
  }

  .campaignDetail__infoCard-icon {
    color: ${Colors.primaryAccent};
    font-size: 18px;
  }

  .campaignDetail__infoCard-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    display: inline-block;
  }

  .campaignDetail__infoCard-label {
    font-size: 12px;
    color: ${Colors.textMuted};
  }

  .campaignDetail__infoCard-value {
    font-size: 15px;
    font-weight: 600;
    color: ${Colors.textStrong};
  }

  .campaignDetail__amounts {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;
    border: 1px solid ${Colors.primaryAccent};
    border-radius: 10px;
    padding: 16px;
  }

  .campaignDetail__amount {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .campaignDetail__amount-icon {
    color: ${Colors.primaryAccent};
    font-size: 20px;
  }

  .campaignDetail__amount-label {
    display: block;
    font-size: 12px;
    color: ${Colors.textMuted};
  }

  .campaignDetail__amount-value {
    font-size: 18px;
    color: ${Colors.textStrong};
  }

  .campaignDetail__amount-value--bold {
    font-weight: 700;
  }

  @media only screen and (max-width: 600px) {
    .campaignDetail__amounts {
      grid-template-columns: 1fr;
    }
  }

  .payments .ant-collapse {
    background: transparent;
  }

  .payments .ant-collapse-item,
  .payments .ant-collapse-item:last-child,
  .payments .ant-collapse-item > .ant-collapse-header {
    border-bottom: none;
  }

  .payments .ant-collapse-content-box {
    padding: 16px 0 0;
  }

  .payments__estado {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .payments__estado-dot {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    display: inline-block;
  }

  .payments__estado-label {
    font-size: 14px;
    font-weight: 700;
    color: ${Colors.textStrong};
    line-height: 16px;
  }

  .payments__estado-value {
    font-size: 12px;
    color: ${Colors.textMuted};
  }

  .payments__pill {
    display: inline-block;
    padding: 2px 12px;
    border-radius: 6px;
    color: ${Colors.white};
    font-size: 12px;
    font-weight: 600;
    line-height: 18px;
  }

  .payments__table-wrap {
    overflow-x: auto;
    border: 1px solid ${Colors.border};
    border-radius: 10px;
  }

  .payments__table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
  }

  .payments__table thead {
    background: ${Colors.surfaceMuted};
  }

  .payments__table th {
    text-align: left;
    color: ${Colors.textSecondary};
    font-weight: 600;
    font-size: 13px;
    padding: 10px 14px;
    border-bottom: 1px solid ${Colors.border};
  }

  .payments__table td {
    padding: 12px 14px;
    border-bottom: 1px solid ${Colors.border};
    color: ${Colors.textStrong};
  }

  .payments__table tbody tr:last-child td {
    border-bottom: none;
  }

  .payments__actions {
    display: flex;
    gap: 8px;
    align-items: center;
  }

  .payments__actions .ant-btn {
    border-radius: 8px;
  }

  .payments__empty {
    text-align: center;
    color: ${Colors.grayMedium};
    padding: 24px;
  }

  .payments__create {
    margin-top: 16px;
    border-radius: 8px;
  }

  .payments__external {
    text-align: center;
    max-width: 480px;
    margin: 0 auto;
  }

  .campaignDetail__map-title {
    margin-top: 0;
  }

  .campaignDetail__section-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 12px;
  }

  .campaignDetail__section-head .campaignDetail__section-title {
    margin: 0;
  }

  .campaignDetail__toggle {
    border: none;
    background: none;
    color: ${Colors.textSecondary};
    font-size: 13px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 0;
  }

  .campaignDetail__toggle:hover {
    color: ${Colors.primaryAccent};
  }

  .campaignDetail__map-count {
    color: ${Colors.textMuted};
    font-weight: 400;
  }

  .screenAds__card {
    scroll-margin-top: 140px;
  }

  .screenAds__list {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 12px;
  }

  .screenAds__pagination {
    margin-top: 16px;
    padding: 12px 0 0;
    background: transparent;
  }

  .screenAd {
    display: grid;
    grid-template-columns: 280px 1fr;
    grid-template-areas: "screen body";
    align-items: start;
    gap: 12px 18px;
    border: 1px solid ${Colors.border};
    border-radius: 16px;
    padding: 18px;
    background: ${Colors.snow};
  }

  .screenAd__body {
    grid-area: body;
    background: ${Colors.surfaceMuted};
    border-radius: 12px;
    padding: 14px;
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  .screenAd__slide {
    display: grid;
    grid-template-columns: minmax(400px,1fr) 390px;
    grid-template-areas: "center rules";
    gap: 14px;
  }

  .screenAd__title {
    font-size: 15px;
    font-weight: 700;
    color: ${Colors.textStrong};
    margin-bottom: 8px
  }

  .screenAd__screen {
    grid-area: screen;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .screenAd__screen-img {
    width: 100%;
    height: 200px;
    object-fit: cover;
    border-radius: 12px;
    display: block;
  }

  .screenAd__status-tag {
    align-self: flex-start;
    padding: 3px 12px;
    border: 1px solid ${Colors.borderStrong};
    border-radius: 8px;
    background: ${Colors.snow};
    font-size: 12px;
    line-height: 16px;
  }

  .screenAd__cms-tag {
    color: ${Colors.atention};
    font-size: 12px;
    line-height: 16px;
  }

  .screenAd__format {
    font-size: 13px;
    color: ${Colors.textSecondary};
  }

  .screenAd__format b {
    color: ${Colors.primaryAccent};
    font-weight: 600;
  }

  .screenAd__detail-btn {
    align-self: flex-start;
    margin-top: 6px;
    padding: 6px 18px;
    border-radius: 8px;
    background: ${Colors.primary};
    color: ${Colors.onPrimary};
    font-size: 13px;
    font-weight: 600;
  }

  .screenAd__detail-btn:hover {
    color: ${Colors.white};
    background: ${Colors.backgroundPrimary};
  }

  .screenAd__center {
    grid-area: center;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .screenAd__creative-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
  }

  .screenAd__version {
    display: inline-block;
    padding: 4px 8px;
    border-radius: 4px;
    background: ${Colors.extraLightPrimary};
    color: ${Colors.primaryAccent};
    font-size: 14px;
    font-weight: 400;
  }

  .screenAd__change {
    padding: 4px 8px;
    border: none;
    border-radius: 4px;
    background: ${Colors.primary};
    color: ${Colors.onPrimary};
    font-size: 14px;
    font-weight: 400;
    cursor: pointer;
  }

  .screenAd__change:hover {
    background: ${Colors.backgroundPrimary};
  }

  .screenAd__media {
    display: flex;
    flex-direction: column;
    gap: 12px;
    min-width: 0;
  }

  .screenAd__media:not(.screenAd__media--side) {
    max-width: 420px;
  }

  .screenAd__media--side {
    flex: 1;
    min-height: 0;
    flex-direction: row;
    align-items: stretch;
  }

  .screenAd__creative-wrap {
    position: relative;
    width: 100%;
    max-width: 100%;
    border-radius: 12px;
    overflow: hidden;
    background: ${Colors.surfaceMuted};
  }

  .screenAd__media--side .screenAd__creative-wrap {
    flex: 0 0 auto;
    width: auto;
  }

  /* The rules panel min-height stretches the row; a stretched square creative grows
     as wide as it is tall and squeezes the mini cards. Size it by width instead. */
  .screenAd__media--square .screenAd__creative-wrap {
    flex: 0 0 40%;
    align-self: flex-start;
  }

  .screenAd__creative-img,
  .screenAd__creative-empty {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .screenAd__play {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 44px;
    height: 44px;
    border: none;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.5);
    color: ${Colors.white};
    font-size: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  .screenAd__play:hover {
    background: rgba(0, 0, 0, 0.7);
  }

  .screenAd__minis {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 10px;
  }

  .screenAd__media--side .screenAd__minis {
    grid-template-columns: repeat(2, 1fr);
    grid-auto-rows: 1fr;
    flex: 1 1 auto;
    align-self: stretch;
  }

  .screenAd__mini {
    display: flex;
    flex-direction: column;
    gap: 4px;
    border: 1px solid ${Colors.border};
    border-radius: 12px;
    padding: 10px;
    background: ${Colors.snow};
  }

  .screenAd__mini-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: ${Colors.primaryAccent};
    margin-bottom: 2px;
  }

  .screenAd__mini-icon {
    width: 26px;
    height: 26px;
    border-radius: 50%;
    background: ${Colors.extraLightPrimary};
    color: ${Colors.primaryAccent};
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
  }

  .screenAd__mini-label {
    font-size: 12px;
    color: ${Colors.textMuted};
  }

  .screenAd__mini-value {
    font-size: 14px;
    font-weight: 600;
    color: ${Colors.textStrong};
  }

  .screenAd__subsidized {
    display: inline-block;
    margin-left: 6px;
    padding: 0 6px;
    border-radius: 6px;
    background: ${Colors.tintWarning};
    color: ${Colors.atention};
    font-size: 11px;
  }

  .screenAd__rules {
    grid-area: rules;
    align-self: stretch;
  }

  .rulesPanel {
    display: flex;
    flex-direction: column;
    height: 100%;
    border: 1px solid ${Colors.border};
    border-radius: 12px;
    background: ${Colors.snow};
    padding: 12px;
  }

  .rulesPanel--empty {
    background: ${Colors.snow};
    border: 1px solid ${Colors.border};
    border-radius: 12px;
    padding: 10px;
    min-height: 320px;
  }

  .rulesPanel__empty-inner {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    background: ${Colors.gray};
    border-radius: 8px;
    padding: 24px;
  }

  .rulesPanel__empty-inner .anticon {
    font-size: 44px;
    color: #cfd3d9;
    margin-bottom: 14px;
  }

  .rulesPanel__empty-text {
    max-width: 190px;
    color: ${Colors.textMuted};
    font-size: 14px;
    line-height: 1.5;
  }

  .rulesPanel__box {
    flex: 1;
    border: 1px solid ${Colors.border};
    border-radius: 10px;
    padding: 14px;
    background: ${Colors.surfaceMuted};
  }

  .rulesPanel__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 4px;
  }

  .rulesPanel__title {
    font-size: 16px;
    font-weight: 700;
    color: ${Colors.textStrong};
  }

  .rulesPanel__rule {
    font-size: 16px;
    font-weight: 700;
    color: ${Colors.textStrong};
  }

  .rulesPanel__label {
    font-size: 14px;
    color: ${Colors.coal};
    margin: 16px 0 8px;
  }

  .rulesPanel__dates,
  .rulesPanel__hours {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .rulesPanel__input {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    border: 1px solid ${Colors.borderStrong};
    border-radius: 8px;
    padding: 9px 12px;
    font-size: 14px;
    color: ${Colors.textStrong};
    background: ${Colors.snow};
  }

  .rulesPanel__input .anticon {
    color: ${Colors.textMuted};
  }

  .rulesPanel__sep {
    color: ${Colors.textMuted};
    flex: none;
  }

  .rulesPanel__days {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
  }

  .rulesPanel__day {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
    color: ${Colors.textStrong};
  }

  .rulesPanel__check {
    width: 18px;
    height: 18px;
    border-radius: 3px;
    border: 1px solid ${Colors.borderStrong};
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    color: transparent;
  }

  .rulesPanel__check--on {
    background: #c0c4cc;
    border-color: ${Colors.borderStrong};
    color: ${Colors.white};
  }

  .rulesPanel__pager,
  .screenAd__ad-pager {
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 13px;
    color: ${Colors.textSecondary};
  }

  .rulesPanel__pager {
    justify-content: space-between;
    border-top: 1px solid ${Colors.border};
    margin: 12px -12px 0;
    padding: 12px 12px 0;
  }

  .rulesPanel__pager-label {
    color: ${Colors.primaryAccent};
    font-weight: 600;
  }

  .screenAd__ad-pager {
    justify-content: space-between;
    margin-top: 12px;
  }

  .screenAd__ad-pager-label {
    flex: 1;
    text-align: center;
    color: ${Colors.textMuted};
  }

  .screenAd__arrow {
    border: 1px solid ${Colors.borderStrong};
    background: ${Colors.snow};
    border-radius: 8px;
    width: 30px;
    height: 30px;
    cursor: pointer;
    color: ${Colors.textSecondary};
    display: flex;
    align-items: center;
    justify-content: center;
    flex: none;
  }

  .screenAd__arrow:disabled {
    opacity: 0.4;
    cursor: default;
  }

  @media only screen and (max-width: 1500px) {
    .screenAd__minis {
      grid-template-columns: 1fr 1fr;
    }
  }

  /* Fewer mini cards (cpmi hides playouts): horizontal ads split the row equally */
  .screenAd__media:not(.screenAd__media--side) .screenAd__minis--3 {
    grid-template-columns: repeat(3, 1fr);
  }

  .screenAd__media:not(.screenAd__media--side) .screenAd__minis--2 {
    grid-template-columns: repeat(2, 1fr);
  }

  /* Side layout keeps 2 columns: the last card of an odd count takes the whole row */
  .screenAd__media--side .screenAd__minis--3 .screenAd__mini:last-child {
    grid-column: span 2;
  }

  @media only screen and (max-width: 1200px) {
    .screenAd__slide {
      grid-template-columns: 1fr;
      grid-template-areas:
        "center"
        "rules";
    }
  }

  @media only screen and (max-width: 700px) {
    .screenAd {
      grid-template-columns: 1fr;
      grid-template-areas:
        "screen"
        "body";
    }
    .screenAd__minis {
      grid-template-columns: 1fr 1fr;
    }
  }

  .consumo__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 12px;
  }

  .consumo__title {
    margin: 0;
  }

  .consumo__toggle {
    border: none;
    background: none;
    color: ${Colors.textSecondary};
    font-size: 13px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 0;
  }

  .consumo__toggle:hover {
    color: ${Colors.primaryAccent};
  }

  .consumo__panel {
    border: 1px solid ${Colors.border};
    border-radius: 10px;
    padding: 18px;
  }

  .consumo__panel-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 12px;
  }

  .consumo__subtitle {
    font-size: 13px;
    color: ${Colors.textSecondary};
  }

  .consumo__currency {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
  }

  .consumo__cur--off {
    color: ${Colors.textMuted};
  }

  .consumo__cur--on {
    color: ${Colors.primaryAccent};
    font-weight: 600;
  }

  .consumo__chart {
    height: 320px;
  }

  .consumo__loading {
    height: 320px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .consumo__legend {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 16px;
    margin-top: 14px;
    flex-wrap: wrap;
  }

  .consumo__legend-left {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .consumo__legend-item {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    color: ${Colors.textSecondary};
  }

  .consumo__sw {
    display: inline-block;
    flex: none;
  }

  .consumo__sw--bar {
    width: 12px;
    height: 12px;
    border-radius: 3px;
    background: ${Colors.primary};
  }

  .consumo__sw--line {
    width: 16px;
    height: 3px;
    border-radius: 2px;
    background: #1e4fd6;
  }

  .consumo__legend-right {
    text-align: right;
  }

  .consumo__total-label {
    display: block;
    font-size: 13px;
    color: ${Colors.textMuted};
  }

  .consumo__total-value {
    font-size: 16px;
    font-weight: 700;
    color: ${Colors.primaryAccent};
  }

  .consumo__empty {
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${Colors.grayMedium};
  }

  .campaignDetail__placeholder {
    padding: 48px;
    text-align: center;
    color: ${Colors.grayMedium};
    border: 1px dashed ${Colors.grayMedium};
    border-radius: 8px;
  }
`;

export default CampaignDetailHolder;
